import { useNavigate, useParams } from 'react-router-dom';

import { useDeleteEmployeeBankAccount, useEmployeeBankAccounts } from '../bankAccounts';
import { BankAccountsManager } from './BankAccountsManager';

/** HR-side view of an employee's payout accounts. Add/edit route to a dedicated
 * form page (not a modal); HR / Founder / Super Admin / Accountant manage. */
export function BankAccountsPanel({
  employeeId,
  canManage,
}: {
  employeeId: number;
  canManage: boolean;
}) {
  // The employee's public_id from the detail route — used to build the form URL.
  const { publicId = '' } = useParams();
  const navigate = useNavigate();
  const { data, isPending } = useEmployeeBankAccounts(employeeId);
  const remove = useDeleteEmployeeBankAccount(employeeId);

  const base = `/hrm/employees/${publicId}/bank-accounts`;

  return (
    <BankAccountsManager
      accounts={data?.results ?? []}
      isPending={isPending}
      canManage={canManage}
      onAdd={() => navigate(`${base}/new`)}
      onEdit={(a) => navigate(`${base}/${a.public_id}/edit`)}
      onDelete={(id) => remove.mutateAsync(id)}
      emptyText="No bank accounts on file for this employee."
    />
  );
}
